var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 2H6.3637C5.15872 2 4.18188 2.97683 4.18188 4.18182V15.8182C4.18188 17.0232 5.15872 18 6.3637 18H13.6364C14.8414 18 15.8182 17.0232 15.8182 15.8182V4.18182C15.8182 2.97683 14.8414 2 13.6364 2Z",
    stroke: "#667085",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54553 15.0909H11.4546",
    stroke: "#667085",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.0b6cf096c2d1d8e04ade4949491d184d.svg";
export { ForwardRef as ReactComponent };